import React from "react";
import Navbar from "../../LandingPage/Navbar/Navbar";
import MediaCoverageSlider from "../../NewsRoom/MediaCoverageSlider/MediaCoverageSlider";
import MediaTabs from "../../NewsRoom/MediaTabs/MediaTabs";
import Footer2 from "../../Footer2/Footer2";
import TopBar from "../../EdofSectionNew2/TopBar/TopBar";
const NewsRoomPageNew = () => {
  return (
    <div>
      <TopBar />
      <Navbar />
      <MediaCoverageSlider />
      <MediaTabs />
      <Footer2 />
    </div>
  );
};

export default NewsRoomPageNew;
